import styled, { css } from 'styled-components';
import { Box } from '@mui/material';

import { ReactComponent as PostsIcon } from '../../../assets/icons/v2/notes.svg';
import { ReactComponent as ReportsIcon } from '../../../assets/icons/warning-error.svg';
import { ReactComponent as NotificationIcon } from '../../../assets/notification-bell.svg';
import { ReactComponent as CommunityIcon } from '../../../assets/icons/v2/people.svg';
import Tabs from '../../components/Tabs';
import { StyledTab as Tab } from '../../components/Tabs/styles';

import colors from '../../../styles/colors';

const iconStyles = css`
  width: 25px;
  height: 25px;

  > path {
    stroke: ${colors.shades.secondary8};
    fill: ${colors.shades.secondary5};
  }
`;

const Container = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.shades.gamma5};
  position: relative;
`;

const StyledTabs = styled(Tabs)`
  border-bottom: unset;
  min-height: unset;

  ${Tab} {
    border-radius: unset;
    min-width: unset;
    padding: 20px 15px;
    column-gap: 10px;
    background-color: ${colors.shades.gamma5};

    &:not(:first-child) {
      margin-left: 15px;
    }

    &.Mui-selected {
      color: unset;
      background-color: unset;
      box-shadow: inset 0 -3px 0 ${colors.shades.secondary3};
      &::before {
        content: none;
      }
    }
  }
`;

const TabContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: 10px 30px;
  height: calc(100% - 85px);
  z-index: 1;
  background-color: ${colors.base.alpha};
`;

const SelectOption = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledNotificationIcon = styled(NotificationIcon)`
  ${iconStyles}
`;

const StyledPostsIcon = styled(PostsIcon)`
  ${iconStyles}
`;

const StyledReportsIcon = styled(ReportsIcon)`
  ${iconStyles}
`;

const StyledCommunityIcon = styled(CommunityIcon)`
  ${iconStyles}
`;

export {
  Container,
  Header,
  StyledTabs,
  TabContainer,
  StyledNotificationIcon,
  StyledPostsIcon,
  StyledReportsIcon,
  StyledCommunityIcon,
  SelectOption,
};
